import type { Filters } from '~/models/SearchFilters';
import type { MatchesResponse } from '~/models/Housing';
import type { PaginationOptions } from '~/stores/dashboard';

export async function fetchSearchData({
  filters,
  page = 1,
  order = 'default',
  perPage = 10,
}: { filters: Filters } & PaginationOptions): Promise<MatchesResponse> {
  if (!(filters.locationIds.regions.length + filters.locationIds.cities.length + filters.locationIds.areas.length)) {
    return {
      offers: [],
      page,
      perPage,
      totalCount: 0,
    };
  }

  const params: Record<string, string | number | boolean | string[]> = {
    page,
    orderBy: order,
    resultsPerPage: perPage,
  };

  if (filters.locationIds) {
    if (filters.locationIds.regions.length) params['locationIds[regions]'] = filters.locationIds.regions.join(',');
    if (filters.locationIds.cities.length) params['locationIds[cities]'] = filters.locationIds.cities.join(',');
    if (filters.locationIds.areas.length) params['locationIds[areas]'] = filters.locationIds.areas.join(',');
  }

  if (filters.housingType !== null) params['housingType'] = filters.housingType;
  if (filters.properties && filters.properties.length > 0) filters.properties.forEach((id, index) => (params[`properties[${index}]`] = id));
  if (filters.housingProperties && filters.housingProperties.length > 0)
    filters.housingProperties.forEach((id, index) => (params[`housingProperties[${index}]`] = id));
  if (filters.radius !== null) params['radius'] = filters.radius;
  if (filters.rentMax !== null) params['rentMax'] = filters.rentMax;
  if (filters.sizeMin !== null) params['sizeMin'] = filters.sizeMin;
  if (filters.roomsMin !== null) params['roomsMin'] = filters.roomsMin;
  if (filters.storeyMin !== null) params['storeyMin'] = filters.storeyMin;
  if (filters.storeyMax !== null) params['storeyMax'] = filters.storeyMax;
  if (filters.propertySizeMin !== null) params['propertySizeMin'] = filters.propertySizeMin;
  if (filters.wgType && filters.wgType.length > 0) filters.wgType.forEach((id, index) => (params[`wgType[${index}]`] = id));
  params['requireImages'] = filters.requireImages.toString();

  try {
    const { searchAPI } = useBackendRequests();
    const response = await searchAPI.getSearchResult({ params });
    return response;
  } catch (error) {
    console.error('Error fetching search data:', error);
    return {
      offers: [],
      page,
      perPage,
      totalCount: 0,
    };
  }
}
